import React, { useState } from 'react';
import { Redirect} from 'react-router-dom';
//import { useGoogleLogin } from '@react-oauth/google';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { Capacitor } from '@capacitor/core';
import { GoogleLogin, useGoogleLogin } from '@react-oauth/google';
import jwtDecode from "jwt-decode";

import GoogleIcon from './icons/GoogleIcon'

import GA from '../services/ga';
import log from '../services/log';
import auth from '../services/auth';
import CWIcon from './icons/CWIcon';

function SignInButton(props){
  const [isLogged, setIsLogged] = useState(false);
  const [loginInProgress, setLoginInProgress] = useState(false);

  const getUserProfileData = async (accessToken) => {
    const headers = new Headers()
    headers.append('Authorization', `Bearer ${accessToken}`)
    const response = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
      headers
    })
    const data = await response.json();
    return data;
  }

  const authGoogleHandler = async (response) => {
    log.traceTag('Google Object', response)
    setLoginInProgress(true);

    // Get use profile details from Google API based on access_token
    const userProfile = await getUserProfileData(response.access_token);
    log.traceTag('userProfile', userProfile)

    if (userProfile){
      const user = await auth.signIn(userProfile.name, userProfile.email, userProfile.picture)
      log.traceTag('sign in user', user)
      GA.track({
        category: 'Retention',
        action: 'signin',
      })
      setIsLogged(true);
      setLoginInProgress(false);
    } else {
      setIsLogged(false);
      setLoginInProgress(false);
    }
  }

  const login = useGoogleLogin({
    onSuccess: authGoogleHandler,
    onError: authGoogleHandler
  });

  const nativeLogin = async () => {
    try{
      // WARNING: activate for prod mode
      log.traceTag('nativeLogin:init')
      GoogleAuth.initialize();
      log.traceTag('nativeLogin:start', auth.getUser())
      var userProfile = await GoogleAuth.signIn();
      log.traceTag('nativeLogin:userProfile', userProfile)
      
      // For Dev
      /*var userProfile = {
        email: 'uvimateapp@gmail.com',
        displayName: 'DEV',
        imageUrl: null
      }*/
  
      if (userProfile){
        const user = await auth.signIn(userProfile.displayName, userProfile.email, userProfile.imageUrl)
        log.traceTag('sign in user', user)
        if (!user) return;
        GA.track({
          category: 'Retention',
          action: 'signin',
        })
        setIsLogged(true);
        setLoginInProgress(false);
      } else {
        setIsLogged(false);
        setLoginInProgress(false);
      }
    } catch(err){
      log.traceTag('nativeLogin error', err);
      setLoginInProgress(false);
    }
  }
  
  if (isLogged) {
    return <Redirect to={{
      pathname: '/dashboard'
    }}/>;
  }

  const handleSuccess = async (credentialResponse) => {
    const userProfile = jwtDecode(credentialResponse.credential);
    //console.log('Decoded JWT', decoded);
    /*if (onGoogleProfile) {
      onGoogleProfile(decoded);
    }*/
    if (userProfile){
      const user = await auth.signIn(userProfile.name, userProfile.email, userProfile.picture)
      log.traceTag('sign in user', user)
      GA.track({
        category: 'Retention',
        action: 'signin',
      })
      setIsLogged(true);
      setLoginInProgress(false);
    } else {
      setIsLogged(false);
      setLoginInProgress(false);
    }
  };

  const align = props.align || 'center';
  const isLeft = align === 'left';
  const containerAlignment = isLeft ? 'items-start' : 'items-center';
  const textAlignment = isLeft ? 'text-left' : 'text-center';

  return (
    <div className={`flex flex-col ${containerAlignment}`}>
      {Capacitor.isNativePlatform() &&
        <button
          type="button"
          onClick={nativeLogin}
          disabled={props.disabled || loginInProgress}
          className="inline-flex min-h-[44px] items-center justify-center gap-3 rounded-full bg-green-700 px-5 py-2 text-sm font-bold leading-tight text-white shadow-sm transition-colors duration-150 hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-1 active:bg-green-900 disabled:cursor-not-allowed disabled:opacity-60"
        >
          <span className="inline-flex flex-shrink-0 items-center">
            <GoogleIcon iconSize={props.iconSize} color='white'></GoogleIcon>
          </span>
          <span className="whitespace-nowrap">
            {!props.children && 'Sign in with Google'}
            {props.children && props.children}
          </span>
        </button>
      }
      {!Capacitor.isNativePlatform() &&
        <div className="inline-block">
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={() => {
              GA.track('signinError', 'signinError');
            }}
            text="signin_with"
            theme={"filled_blue"}
            shape="pill"
          />
        </div>
      }
      {props.showDescription && 
        <div className={`mb-1 mt-3 ${textAlignment} text-sm text-gray-500`}>
          <span>Set Up In <b>30 Seconds</b>. It's <b>Free</b> to Start. </span> &nbsp;
          {loginInProgress && 
            <div className="spinner-btn-dark">
              <div className="bounce1"></div>
              <div className="bounce2"></div>
              <div className="bounce3"></div>
            </div> }
        </div>
      }
    </div>
  );
};

SignInButton.defaultProps = {
  showDescription: true,
  iconSize: 24,
  align: 'center'
};

export default SignInButton;
